"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLevelEntityLike = exports.LevelEntity = exports.LevelEntityClassName = void 0;
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const DeviceEnabledType_1 = require("./Device/DeviceEnabledType");
exports.LevelEntityClassName = 'LevelEntity';
class LevelEntity extends DeviceEnabledType_1.DeviceEnabledType {
    constructor(ob) {
        if (ob.type !== undefined && ob.type !== exports.LevelEntityClassName)
            throw new Error(`Tried to create a ${exports.LevelEntityClassName} from a ${ob.type} object!`);
        super(exports.LevelEntityClassName, { ...ob });
        this.type = ob.type ?? exports.LevelEntityClassName;
        this.level = ob.level ?? null;
        this.score_level = ob.score_level ?? null;
        this.batteryPercentage = ob.batteryPercentage ?? null;
        this.deviceBatteryVoltage = ob.deviceBatteryVoltage ?? null;
        this.rssi = ob.rssi ?? null;
        this.sf = ob.sf ?? null;
        this.snr = ob.snr ?? null;
        this.fCnt = ob.fCnt ?? null;
        this.deviceEui = ob.deviceEui ?? null;
        this.gatewayEui = ob.gatewayEui ?? null;
    }
    getUserAttributes() {
        return {
            ...super.getUserAttributes(),
            name: {
                type: 'String',
                editable: true,
                required: true,
                label: 'Name',
                name: 'name',
                description: 'identification',
                validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
            },
            level: {
                label: 'Level',
                type: 'Number',
                units: 'm',
                precision: 3,
                displayFn: (d) => (d ? d / 1000 : d),
                editable: false,
            },
        };
    }
}
exports.LevelEntity = LevelEntity;
const isLevelEntityLike = (ob) => {
    return (0, iotv_v3_types_1.isValidBusinessObject)(ob) && ob.type === exports.LevelEntityClassName;
};
exports.isLevelEntityLike = isLevelEntityLike;
